import React from 'react';
import { Phone, Mail, ArrowRight } from 'lucide-react';
export function ContactForm() {
  return <section className="w-full bg-gray-50 py-32 px-6 lg:px-8 relative" data-id="element-10">
      {/* Geometric accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-white -skew-x-12 transform translate-x-1/3 pointer-events-none" data-id="element-11" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          <div data-id="element-14">
            <h2 className="text-5xl md:text-7xl font-black text-black mb-8 tracking-tighter leading-none" data-id="element-15">
              GET YOUR <br data-id="element-16" />
              <span className="text-slate-600" data-id="element-17">CASH OFFER</span> <br data-id="element-18" />
              TODAY.
            </h2>
            <p className="text-xl font-medium text-gray-700 mb-12 max-w-md" data-id="element-19">
              Ready to sell? Reach out directly and we'll provide a fair,
              no-obligation cash offer for your property within 24 hours.
            </p>

            <div className="space-y-6" data-id="element-20">
              <div className="flex items-center gap-4" data-id="element-21">
                <div className="w-12 h-12 bg-black flex items-center justify-center text-white font-bold text-xl" data-id="element-22">
                  1
                </div>
                <p className="text-lg font-bold text-black" data-id="element-23">
                  Contact us via phone or email
                </p>
              </div>
              <div className="flex items-center gap-4" data-id="element-24">
                <div className="w-12 h-12 bg-black flex items-center justify-center text-white font-bold text-xl" data-id="element-25">
                  2
                </div>
                <p className="text-lg font-bold text-black" data-id="element-26">
                  We analyze your property value
                </p>
              </div>
              <div className="flex items-center gap-4" data-id="element-27">
                <div className="w-12 h-12 bg-slate-600 flex items-center justify-center text-white font-bold text-xl" data-id="element-28">
                  3
                </div>
                <p className="text-lg font-bold text-black" data-id="element-29">
                  Get your cash offer instantly
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-6" data-id="element-30">
            <a href="tel:630-639-3533" className="group flex items-center gap-6 p-8 bg-white border-2 border-gray-200 hover:border-slate-600 hover:shadow-2xl transition-all duration-300" data-id="element-31">
              <div className="w-20 h-20 bg-slate-600 flex items-center justify-center text-white shrink-0 group-hover:bg-black transition-colors" data-id="element-32">
                <Phone className="w-10 h-10" data-id="element-33" />
              </div>
              <div className="flex-1" data-id="element-34">
                <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-35">
                  Call Us Now
                </p>
                <p className="text-3xl font-black text-black group-hover:text-slate-600 transition-colors mb-2" data-id="element-36">
                  630-639-3533
                </p>
                <p className="text-sm text-gray-600 font-medium" data-id="element-37">
                  Speak with our team directly
                </p>
              </div>
              <ArrowRight className="w-6 h-6 text-slate-600 group-hover:translate-x-2 transition-transform" data-id="element-38" />
            </a>

            <a href="mailto:ravenadvisorsllc@gmail.com" className="group flex items-center gap-6 p-8 bg-white border-2 border-gray-200 hover:border-slate-600 hover:shadow-2xl transition-all duration-300" data-id="element-39">
              <div className="w-20 h-20 bg-black flex items-center justify-center text-white shrink-0 group-hover:bg-slate-600 transition-colors" data-id="element-40">
                <Mail className="w-10 h-10" data-id="element-41" />
              </div>
              <div className="flex-1" data-id="element-42">
                <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-43">
                  Email Us
                </p>
                <p className="text-2xl font-black text-black group-hover:text-slate-600 transition-colors mb-2 break-all" data-id="element-44">
                  ravenadvisorsllc@gmail.com
                </p>
                <p className="text-sm text-gray-600 font-medium" data-id="element-45">
                  Get a response within hours
                </p>
              </div>
              <ArrowRight className="w-6 h-6 text-slate-600 group-hover:translate-x-2 transition-transform" data-id="element-46" />
            </a>

            <div className="bg-black p-6 text-white" data-id="element-47">
              <p className="text-sm font-bold uppercase tracking-wider text-slate-400 mb-2" data-id="element-48">
                Why Choose Us?
              </p>
              <p className="text-lg font-medium" data-id="element-49">
                No fees, no commissions, no hassle. Just a fair cash offer and a
                fast closing on your timeline.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}